import TumengMultiImg from './src/index.vue'

TumengMultiImg.install = function(Vue) {
  Vue.component(TumengMultiImg.name, TumengMultiImg)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengMultiImg)
}

export default TumengMultiImg
